module.exports = __webpack_public_path__ + "assets/img/116@3x.62b7cfca.png";